// Shared role -> CSS class / display label, used anywhere a role badge is
// rendered (Users.jsx, Roles.jsx member rows, Sidebar.jsx profile block) so
// the five role colors/names never drift apart between pages.
export const ROLE_CLASS = {
  superadmin: "role-superadmin",
  admin:      "role-admin",
  sekretaris: "role-sekretaris",
  bendahara:  "role-bendahara",
  user:       "role-user",
};

export const ROLE_LABEL = {
  superadmin: "Superadmin",
  admin:      "Admin",
  sekretaris: "Sekretaris",
  bendahara:  "Bendahara",
  user:       "User",
};
